import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store';

Vue.use(Router)


const requireAuth = (to, from, next) => {

   if(store.state.UserRoleId == 'coach'){
      next('/login')
   }else if(store.state.UserRoleId == 'student'){
      next('/student')
   }else{
      next('/login')
   }
}



const router = new Router({
   mode: 'history',
   linkExactActiveClass: 'subnav__active',
   routes:[
      //HELPERS ROUTER
      {
         path: '/',
         name: 'home',
         beforeEnter : requireAuth
      },
      {
        name: 'WelcomePage',
        path: '/neo',
        component: () => import ('../views/welcome-page/WelcomePage.vue'),
        meta:{
          PgLogin:true
        }
      },
      {
        name: 'AboutPage',
        path: '/about',
        component: () => import ('../views/contactUsB2i/aboutUs.vue'),
        meta:{
          PgLogin:true
        }
      },
      {
        name: 'ContactPage',
        path: '/contact',
        component: () => import ('../views/contactUsB2i/ContactUs.vue'),
        meta:{
          PgLogin:true
        }
      },
      {
        name: 'LoginNeo',
        path: '/login',
        component: () => import ('../views/loginB2I/Login.vue'),
        meta:{
          PgLogin:true
        }
      },
      {  
         name:'Forgot password',
         path: "/forgot-password",
         component: () => import ('../views/forgot-password/ForgotPassword.vue'),
        meta:{
          PgLogin:true
        }
      },
      {  
         name:'404',
         path: "*",
         component: () => import ('../views/page-not-found/PageNotFound.vue'),
      },

      //STUDENT ROUTER
      {
         name: 'Student Dashboard',
         path: '/student',
         component: () => import ('../views/dashboard/Dashboard.vue'),
         meta :{
            auth:true,
            permission: 'student'
         }
      },
      {
         name: 'Student Session Summary',
         path: '/student/live/summary',
         component: () => import ('../views/session-summary/StudentSessionSummary.vue'),
         meta :{
            auth:true,
            permission: 'student'
         }
      },
      {
         name: 'Student See Coach',
         path: '/student/view',
         component: () => import ('../views/profile/CoachProfileView.vue'),
         meta :{
            auth:true,
            permission: 'student'
         }
      },
      {
         name: 'Student Profile',
         path: '/student/profile',
         component: () => import ('../views/profile/StudentProfileView.vue'),
         meta :{
            auth:true,
            permission: 'student'
         }
      },
      {
         name: 'Student Edit Profile',
         path: '/student/setting/profile',
         component: () => import ('../views/profile/Profile.vue'),
         meta :{
            auth:true,
            permission: 'student'
         }
      },
      {
         name: 'Student Account Setting',
         path: '/student/settings',
         component: () => import ('../views/student-account-settings/AccountSettings.vue'),
         meta :{
            auth:true,
            permission: 'student'
         }
      },
      {
         name: 'Student Sessions',
         path: '/student/sessions',
         component: () => import ('../views/sessions/Session.vue'),
         meta :{
            auth:true,
            permission: 'student'
         }
      },
      {
         name: 'Study Progress Report',
         path: '/student/studyprogressreport',
         component: () => import ('../views/study-progress-report/StudyProgressReport.vue'),
         meta :{
            auth:true,
            permission: 'student'
         }
      },
      {
         name: 'Student Token',
         path: '/student/token',
         component: () => import ('../views/token/Token.vue'),
         meta :{
            auth:true,
            permission: 'student'
         }
      },
      {
         name: 'Book a Coach',
         path: '/student/bookcoach',
         component: () => import ('../views/bookcoach/BookCoach.vue'),
         meta :{
            auth:true,
            permission: 'student'
         }
      },
      {
         name: 'Student Session Simulator',
         path: '/student/opentok-simulator',
         component: () => import ('../views/opentok-simulator/OpentokSimulator.vue'),
         meta :{
            auth:true,
            permission: 'student'
         }
      },
      {
         name: 'Student Live Session',
         path: '/student/live/opentok',
         component: () => import ('../views/opentok-live-session/OpentokLiveSession.vue'),
         meta :{
            auth:true,
            permission: 'student'
         }
      },
      {
         name: 'Student Agora Live Session',
         path: '/student/live',
         component: () => import ('../views/agora-session/AgoraSession.vue'),
         meta :{
            auth:true,
            permission: 'student'
         }
      },
      {
         name: 'HelpPage',
         path: '/student/help',
         component: () => import ('../views/help-page/Help.vue'),
         meta :{
            auth:true,
            permission: 'student'
         }
      },
      //END STUDENT ROUTER
      {
         name: 'Coach Agora Live Session',
         path: '/coach/live',
         component: () => import ('../views/agora-session/AgoraSession.vue'),
         meta :{
            auth:true,
            permission: 'coach'
         }
      },

      {
         path: "/timezone",
         component: () => import ('../components/timezone-auth/timezone-auth'),
         beforeEach(to, from, next){
            if (state.DataAdditional.data.timezone == false) {
               return next('/timezone')
            } else {
               return next()
            }
         }
      },
      {
           name: 'Student Agora Simulator',
           path: '/student/agora-simulator',
           component: () => import ('../views/agora-simulator/agora-simulator.vue'),
           meta :{
              auth:true,
              permission: 'student'
           }
      },
      {
             name: 'StudentAllNotifications',
             path: '/student/notifications',
             component: () => import ('../views/headerNotifications/HeaderNotifications.vue'),
             meta :{
                auth:true,
                permission: 'student'
             }
          },
    {
         name: 'StudentAgoraVideoPlayer',
         path: '/student/video',
         component: () => import ('../views/AgoraVideoPlayer/AgoraVideoPlayer.vue'),
         meta :{
            auth:true,
            permission: 'student'
         }
      },
      //END MIXING ROUTER


      //COACH ROUTER
      {
         name: 'Coach Session Summary',
         path: '/coach/live/summary',
         component: () => import ('../views/session-summary/CoachSessionSummary.vue'),
         meta :{
            auth:true,
            permission: 'coach'
         }
      },
      
      {
         name: 'Coach Schedules',
         path: '/coach/coachschedules',
         component: () => import ('../views/coachSchedules/CoachSchedules.vue'),
         meta :{
            auth:true,
            permission: 'coach'
         }
      },
      {
         name: 'Coach Sessions',
         path: '/coach/session',
         component: () => import ('../views/coach-sessions/Session.vue'),
         meta :{
            auth:true,
            permission: 'coach'
         }
      },
      {
         name: 'Coach Token',
         path: '/coach/coachtoken',
         component: () => import ('../views/coach-token/CoachToken.vue'),
         meta :{
            auth:true,
            permission: 'coach'
         }
      },
      {
         name: 'Coach Script',
         path: '/coach/script',
         component: () => import ('../views/coaching-script/CoachingScript.vue'),
         meta :{
            auth:true,
            permission: 'coach'
         }
      },
      {
         name: 'Coach Live Session',
         path: '/coach/live/opentok',
         component: () => import ('../views/opentok-live-session/OpentokLiveSession.vue'),
         meta :{
            auth:true,
            permission: 'coach'
         }
      },
      //END COACH ROUTER

   ]
})

// router.beforeEach((to,from,next) => {
//    if (to.matched.some(record => record.meta.auth)) {
//       
//       if (!store.getters.IS_AUTHENTICATION  || !store.state.UserRoleId) {
//          next({
//             path: '/login'
//          })
//       } else {
//         const permission =  store.state.UserRoleId
//          if (to.matched.some(record => record.meta.permission)) {
//             if (permission === to.meta.permission) {
//                next();
//             } else {
//                next('/');
//             }
//          } else {
//             next();
//          }
//       }
//    } else {
//       next();
//       const logins = true
//       if (to.matched.some(record => record.meta.logins)){
//          if (store.getters.IS_AUTHENTICATION && logins === to.meta.logins) {
//             next('/');
//          }else{
//             next()
//          }
//       }else{
//          next()
//       }
//    }
// })

router.beforeEach((to, from, next) => {
  // console.log(to)
  const authUser = store.getters.IS_AUTHENTICATION
  if (to.meta.auth) {
    if (authUser) {
        const permission =  store.state.UserRoleId
        if(permission === to.meta.permission){
           next()
        }else{
           next({path: '/'})
        }
    } else {
      next({path: '/login'})
    }
  }else if(to.meta.PgLogin){
        if(authUser){
            next({path: '/'}) 
        }else{
              next()  
        }
  }
  next()
})

export default router;



// WEBPACK FOOTER //
// ./src/router/router.js